import { Dispatch, SetStateAction } from "react";

const setObjectState = <T>(setState: Dispatch<SetStateAction<T>>, key: string, value?: string) => {
    const keys = key.split('.');
    if (keys.length === 1) {
        setState(prevState => ({ ...prevState, [key]: value }));
    } else {
        setState(prevState => {
            let updatedState: any = { ...prevState };
            let current = updatedState;
            for (let i = 0; i < keys.length - 1; i++) {
                current = current[keys[i]];
            }
            current[keys[keys.length - 1]] = value;
            return updatedState;
        });
    }
};

export default setObjectState;